// /teams/:teamId/projects/:projectId/flows/:flowId — full-bleed FlowViewer
// with breadcrumb at the top. Click any node opens the side panel inspector.

import { useParams } from 'react-router-dom'
import { FlowViewer } from '../../components/dashboard/FlowViewer.jsx'
import { PageHeader } from '../../components/dashboard/PageHeader.jsx'
import { useFlow, useProject } from '../../lib/data-hooks.js'

export function FlowDetail() {
  const { teamId, projectId, flowId } = useParams()
  const { data: project } = useProject(teamId, projectId)
  const { data: flow, loading, error } = useFlow(teamId, projectId, flowId)

  return (
    <div className="flex h-[calc(100vh-8.25rem)] flex-col">
      <PageHeader
        breadcrumb={[
          { label: 'Teams', to: '/teams' },
          { label: teamId, to: `/teams/${teamId}` },
          { label: project?.name ?? projectId, to: `/teams/${teamId}/projects/${projectId}` },
          { label: 'Flows', to: `/teams/${teamId}/projects/${projectId}/flows` },
          { label: flow?.name ?? flowId },
        ]}
        title={flow?.name ?? flowId}
        subhead="Click a node to inspect its route, asserts, inputs, and transitions"
      />

      {loading && <p className="px-6 py-8 text-sm text-[var(--color-schist)]">Loading flow…</p>}
      {error && (
        <p className="px-6 py-8 text-sm text-[var(--color-failed)]" role="alert">
          {error.message}
        </p>
      )}
      {!loading && !flow && !error && (
        <p className="px-6 py-8 text-sm text-[var(--color-schist)]">
          Flow not found. It may have been deleted.
        </p>
      )}
      {flow?.yaml && (
        <div className="flex-1 overflow-hidden">
          <FlowViewer yaml={flow.yaml} />
        </div>
      )}
    </div>
  )
}
